
import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';

declare var moment: any;
@Injectable()
export class UtilsService {
    public localStorageKey = {
        equipmentType: 'setEquipmentType',
        company: 'setCompany',
        companyRefference: 'companyRefference',
    };
    constructor() { }

}




// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/service/utils.service.ts